// ============================================
// App Constants (ES6)
// 앱 전체에서 사용하는 상수 정의
// ============================================

export const APP = {
  NAME: '호신고',
  NAME_EN: 'HOSINGO',
  DOMAIN: 'saju-f8122.web.app',
};

export const CURRENCY = {
  NAME: '복채',
  UNIT: '복채',
};

export const CHARACTER = {
  NAME: '점술가',
  NAME_PLURAL: '점술가',
};
